import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
  ChangeDetectorRef,
} from '@angular/core';
import { CoreService } from 'src/app/services/core.service';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { Router } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';
import { AlertNotificationComponent } from '../../alert-notification/alert-notification.component';
import { AuthService } from 'src/app/pages/authentication/service/auth.service';
import { ConfigRutService } from 'src/app/services/config-rut.service';
import { PushNotificationService } from 'src/app/services/push-notification.service';
import { NotificationsService } from 'src/app/services/notifications.service';
import { AlertNotificactions, AlertNotificactionsCount } from '../../interface/headers.interface';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    NgScrollbarModule,
    TablerIconsModule,
    MaterialModule,
    OverlayModule,
    AlertNotificationComponent,
  ],
  styleUrls: ['./styleheader.scss'],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Input() isMobile = null;
  @Input() isClient = "";
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();
  public alerts: AlertNotificactions[] = [];
  public alertsMinuteSize = 15;
  public alertsQuoteSize = 15;
  public alertPendingCount: AlertNotificactionsCount = { countPendingTotal: 0, countPendingMinutes: 0, countPendingQuotes: 0 };
  private router: Router;
  public showFiller = false;
  public isOpen = false;
  public showButtons: boolean = false;
  public notifySucceed: boolean = true;
  public cerrarSession() {
    localStorage.removeItem('token');
    this.router.navigate(['/login']);
  }
  public companiesAssocied: string[];
  public companiesAssociedwithdv: string[];
  public selectedCompany: string;
  public totalNotifications: number = 0;
  private intervalId: any;

  constructor(
    private cdRef: ChangeDetectorRef,
    private notification: NotificationsService,
    private vsidenav: CoreService,
    public dialog: MatDialog,
    private translate: TranslateService,
    private auth: AuthService,
    private configRutService: ConfigRutService,
    private cdr: ChangeDetectorRef,
    private pushNotificationService: PushNotificationService
  ) {
    translate.setDefaultLang('en');
  }

  ngOnInit(): void {
    this.companiesAssocied = this.auth.getCompaniesAssocied().split(";");
    this.companiesAssociedwithdv = this.configRutService.formatRutListWithDv(this.companiesAssocied);
    this.auth.watchStorageSession().subscribe( value => {
      this.selectedCompany = this.configRutService.formatRutWithDv(parseInt(value));
    });
    this.pushNotificationService.hasActiveSubscription().then((hasPushEnabled) => {
      if(!hasPushEnabled) {
        this.pushNotificationService.subscribeToPush();
      }
    });
    this.getNotification(this.alertsMinuteSize, this.alertsQuoteSize);
    this.startAutoRefresh();
  }

  ngAfterViewInit(): void {
    this.selectedCompany = this.configRutService.formatRutWithDv(parseInt(this.auth.getItemSession("companieSelected")));
    this.cdr.detectChanges(); 
  }

  onCompanyChange(selected: string): void {
    this.selectedCompany = this.configRutService.transformStringRut(selected).toString();
    this.auth.setItemSession("companieSelected", this.selectedCompany);
  }

  public openCloseMobile() {
    this.isOpen = false;
    this.toggleMobileNav.emit();
  }

  openAndCloseNotify() {
    if(this.isOpen) {
      this.startAutoRefresh();
    }
    if(!this.isOpen) {
      this.stopAutoRefresh();
      this.notifySucceed = false;
    }
    this.isOpen = !this.isOpen;
    this.cdRef.detectChanges();
  }

  updateIconNotify() {
    this.notifySucceed = true;
  }

  closeNotify() {
    this.isOpen = false;
  }

  getNotification(alertsMinuteS: number, alertsCuoteS: number) {
    this.getNotificationCountPending();
    this.notification.getNotifications(alertsMinuteS, alertsCuoteS).subscribe({
      next: (response) => {
        this.alerts = response;
      },
      error:() => {
        console.log("Error al cargar Notificaciones");
      }
    });
  }

  getNotificationCountPending() {
    this.notification.getNotificationsPendingCount().subscribe({
      next: (response) => {
        this.alertPendingCount = response;
        this.permisonViewNotification();
      },
      error:() => {
        console.log("Error al cargar Notificaciones");
      }
    });
  }

  loadMoreNotifications() {
    this.alertsMinuteSize += 5;
    this.alertsQuoteSize += 5;
    this.getNotification(this.alertsMinuteSize, this.alertsQuoteSize);
  }

  public startAutoRefresh(): void {
    this.intervalId = setInterval(() => {
      this.getNotificationCountPending();
      this.getNotification(this.alertsMinuteSize, this.alertsQuoteSize);
    }, 30000); // 60000 ms = 1 minuto
  }

  public stopAutoRefresh(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  public permisonViewNotification() {
    this.totalNotifications = 0;
    const permissionsUsers = this.auth.getUserPermissions();
    const permisons = permissionsUsers.filter((e) => 
      e.includes('ViewQuotesNotifications') || e.includes('ViewMinutesNotifications') || e.includes('ViewAllNotifications')
    ).map((e) => e);
    
    if (permisons.some((e) => e === 'ViewAllNotifications')) {
      this.showButtons = true;  
    }

    if (permisons.some((e) => e === 'ViewMinutesNotifications')) {
      this.totalNotifications += this.alertPendingCount.countPendingMinutes;
    }

    if (permisons.some((e) => e === 'ViewQuotesNotifications')) {
      this.totalNotifications += this.alertPendingCount.countPendingQuotes;
    }
 
  }

}